import axios from "axios";

const apiClient = axios.create({
  baseURL: "/api",
  timeout: 30000,
  timeoutErrorMessage: "time out",
  header: {
    "Content-Type": "application/json",
  },
});

const get = async (submitionId) => {
  return apiClient.get(`/submition/${submitionId}`);
};

const create = async (data) => {
  return apiClient.post("/submition", data);
};

const update = async (data) => {
  return apiClient.put(`/submition/${data.submitionId}`, data);
};

const getDocuments = async (submitionId) => {
  return apiClient.get(`/submition/${submitionId}/documents`);
};

const createSecureProcess = async (submitionId) => {
  return apiClient.get(`/submition/${submitionId}/secure`);
};

const createManualProcess = async (submitionId) => {
  return apiClient.get(`/submition/${submitionId}/manual`);
};

export const submitionService = {
  get,
  create,
  update,
  getDocuments,
  createSecureProcess,
  createManualProcess,
};
